export default __webpack_public_path__ + "static/media/Chucky.d2b88045.mp3";